import { createIcon } from '@/utils/factoryUtil'

export const SVGCommonChevronDoubleUp = createIcon('SVGCommonChevronDoubleUp', (props) => (
  <svg viewBox='0 0 50 100' {...props}>
    <path d='M43.16,50c-.92,0-1.85-.25-2.68-.78l-15.46-9.9-15.48,9.9c-2.22,1.42-5.23.85-6.72-1.29-1.48-2.14-.88-5.03,1.34-6.45l15.46-9.9c3.27-2.09,7.5-2.09,10.77,0l15.46,9.9c2.23,1.42,2.83,4.31,1.34,6.45-.93,1.34-2.47,2.07-4.03,2.07h0Z' />
    <path d='M43.16,70c-.92,0-1.85-.25-2.68-.78l-15.46-9.9-15.48,9.9c-2.22,1.42-5.23.85-6.72-1.29-1.48-2.14-.88-5.03,1.34-6.45l15.46-9.9c3.27-2.09,7.5-2.09,10.77,0l15.46,9.9c2.23,1.42,2.83,4.31,1.34,6.45-.93,1.34-2.47,2.07-4.03,2.07h0Z' />
  </svg>
))
